export default __webpack_public_path__ + "static/media/character_assets.39f0a37e.png";